<template>
  <div class="content">
    <slot name="left-sidebar"></slot>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: 'ImLayout'
}
</script>

<style lang="stylus" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/common/im/ImLayout.vue